export enum GenderValues {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum EthnicityValues {
  WHITE = 'WHITE',
  EAST_ASIAN = 'EAST_ASIAN',
  SOUTH_ASIAN = 'SOUTH_ASIAN',
  BLACK = 'BLACK',
  MIDDLE_EASTERN = 'MIDDLE_EASTERN',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
  OTHER = 'OTHER',
}

export enum ParentalMyopiaValues {
  ONE_PARENT = 'ONE_PARENT',
  BOTH_PARENTS = 'BOTH_PARENTS',
  NEITHER = 'NEITHER',
}

export enum EyeSideValues {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum MyopicValues {
  MYOPIC = 'MYOPIC',
  NON_MYOPIC = 'NON_MYOPIC',
}

export enum SerBoundaryType {
  UPPER = 'UPPER',
  LOWER = 'LOWER',
}

export enum PercentileQualifier {
  BELOW = 'BELOW',
  ABOVE = 'ABOVE',
  AROUND = 'AROUND',
}

export enum PredictedAt18Qualifier {
  MORE_MYOPIC_THAN_TOP_PERCENTILE = 'MORE_MYOPIC_THAN_TOP_PERCENTILE',
  LESS_MYOPIC_THAN_BOTTOM_PERCENTILE = 'LESS_MYOPIC_THAN_BOTTOM_PERCENTILE',
  PREDICTION = 'PREDICTION',
  OUT_OF_AGE_BOUNDS_TOO_YOUNG = 'OUT_OF_AGE_BOUNDS_TOO_YOUNG',
  OUT_OF_AGE_BOUNDS_TOO_OLD = 'OUT_OF_AGE_BOUNDS_TOO_OLD',
  MYOPIC_LESS_THAN_6_YEARS_OLD = 'MYOPIC_AND_LESS_THAN_6',
}

export enum SingleMyopRiskAt18Result {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum GraphDataEthnicity {
  WESTERN = 'WESTERN',
  EAST_ASIAN = 'EAST_ASIAN',
}

export enum PremyopeAgeCategory {
  LESS_THAN_9_YEARS = 'LESS_THAN_9_YEARS',
  GREATER_OR_SAME_AS_9_YEARS = 'GREATER_OR_SAME_AS_9_YEARS',
}

export enum RealAxialLengthBoundaries {
  CAT1_CAT2 = 'CAT1_CAT2',
  CAT2_CAT3 = 'CAT2_CAT3',
  CAT3_CAT4 = 'CAT3_CAT4',
}

export enum RealAxialLengthCatagory {
  RISK_CAT1 = 'RISK_CAT1',
  RISK_CAT2 = 'RISK_CAT2',
  RISK_CAT3 = 'RISK_CAT3',
  RISK_CAT4 = 'RISK_CAT4',
}

export enum MyopeProgressionType {
  REAL = 'REAL',
  ESTIMATED = 'ESTIMATED',
}

export enum SingleVisitMyopeAgeCategory {
  LESS_THAN_13_YEARS = 'LESS_THAN_13_YEARS',
  GREATER_OR_SAME_AS_13_YEARS = 'GREATER_OR_SAME_AS_13_YEARS',
}

export enum SingleVisitAnnualSERCategory {
  LESS_MYOPIC_THAN_0P5D = 'LESS_THAN_0P5D',
  MORE_MYOPIC_OR_EQUAL_TO_0P5D = 'EQUAL_OR_MORE_THAN_0P5D',
}
export enum CalculationType {
  PREMYOPES = 'PREMYOPES',
  MYOPES_ONE_VISIT = 'MYOPES_ONE_VISIT',
  MYOPES_MULTI_VISITS = 'MYOPE_MULTI_VISITS',
  NO_CALCULATION_PLOTS_ONLY = 'NO_CALCULATION_PLOTS_ONLY',
}
export enum SERValueType {
  CYCLO = 'CYCLO',
  NON_CYCLO = 'NON_CYCLO',
}
export enum AxialLengthType {
  REAL = 'REAL',
  ESTIMATED = 'ESTIMATED',
}
export enum SERRiskScoreCategory {
  LOW = 'LOW',
  MIDDLE = 'MIDDLE',
  HIGH = 'HIGH',
}

export enum PremyopeRiskScoreCategory {
  LITTLE_TO_NO_RISK = 'LITTLE_TO_NO_RISK',
  LITTLE_RISK = 'LITTLE_RISK',
  MODERATE_RISK = 'MODERATE_RISK',
  HIGH_RISK = 'HIGH_RISK',
}

export enum StandardProgressionWarning {
  CALC_BASED_ON_NON_CYCLO_MEASURES = 'CALC_BASED_ON_NON_CYCLO_MEASURES',
  CALC_BASED_ON_AXIAL_LENGTH_DERIVED_FROM_K_VALUES = 'CALC_BASED_ON_AXIAL_LENGTH_DERIVED_FROM_K_VALUES',
  CALC_BASED_ON_LESS_THAN_11_MONTHS = 'CALC_BASED_ON_LESS_THAN_11_MONTHS',
  CALC_UNAVAILABLE = 'CALC_UNAVAILABLE',
}
